import { useDocumentTitle, useHeadingFocus } from "../config/common";

// Inicio (/portal) provisional, pedido del dueño (2026-10-27): solo el título, para que el enlace de Inicio no salte al
// portal actual cuando no está levantado. No es la migración de Inicio: su contenido real queda pendiente.

/** Página de Inicio con el título del menú y nada más. */
export function HomePage({ title }: { title: string }) {
  useDocumentTitle(title);
  useHeadingFocus(true);
  return <h1>{title}</h1>;
}
